<template>
  <div class="app-shell">
    <app-header :user="user"></app-header>
    <main class="app-main">
      <router-view :user="user"></router-view>
    </main>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Firebase from "firebase";
import Header from "./views/Header.vue";
import Footer from "./views/Footer.vue";

export default {
  data() {
    return {
      user: null,
    };
  },
  mounted() {
    Firebase.auth().onAuthStateChanged((user) => {
      this.user = user || null;
    });
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
  },
};
</script>
